import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

const StyledFooterActions = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${COLOR.secondary[16]};
  margin-top: auto;
  box-sizing: border-box;
  margin: 0 auto;
  width: 100%;
  height: 72px;
  padding: 24px 0;
  background-color: ${COLOR.white};
  z-index: 2;
`;

const LeftActions = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const RightActions = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const AutoSaveWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
`;

export { StyledFooterActions, LeftActions, RightActions, AutoSaveWrapper };
